// extracted by mini-css-extract-plugin
module.exports = {"axisX":"XAxis_axisX__3FMDz","firstTickHidden":"XAxis_firstTickHidden__10N8T"};